import { EdgesGeometry, LineBasicMaterial, LineSegments, Mesh, MeshBasicMaterial, RingGeometry } from 'three';

import { IMeshOptions } from '@/types';

import { AnnoFactory } from './AnnoFactory';

const SEGMENTS = 32;
export class Ring2d {
  /**
   * 创建 2D 环形
   * @param data [x, y, innerRadius, lineWidth] three.js 坐标系
   * @param options 配置项
   * @returns
   */
  static create(data: number[], options: IMeshOptions) {
    const [x, y, radius, lineWidth = 1] = data;
    const { color, opacity: faceOpacity, borderColor } = options;

    const geometry = new RingGeometry(radius, radius + lineWidth, SEGMENTS);
    const material = new MeshBasicMaterial({ color, transparent: true, opacity: faceOpacity });
    const ring = new Mesh(geometry, material);

    const z = AnnoFactory.generateObjectZ(ring);
    ring.position.set(x, y, z);
    ring.userData = { ...options };

    if (borderColor) {
      const border = new LineSegments(
        new EdgesGeometry(geometry),
        new LineBasicMaterial({
          linewidth: 1,
          color: borderColor,
        })
      );
      ring.add(border);
    }

    return ring;
  }
}
